// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stat-card {
  background-color: #e2e8f0;
  padding: 10px;
  width: 150px;
  height: 70px;
  margin: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: transform 0.1s ease-out, box-shadow 0.1s ease-out, background-color 0.2s ease, border-color 0.2s ease;
}
.stat-card .stat-card-main .stat-title {
  color: #686868;
  font-size: 14px;
  margin-bottom: 2px;
  margin-block-start: 0.5em !important;
  margin-block-end: 0.5em !important;
  font-weight: 500 !important;
  transition: color 0.2s ease; /* Smooth color transition for title */
}
.stat-card .stat-card-main .stat-value {
  color: #004a9a;
  font-size: 18px;
  font-weight: bold;
}
.stat-card .stat-card-main .stat-value .currency-symbol {
  font-size: 18px;
}
.stat-card .stat-card-main .stat-placeholder {
  width: 40px;
  height: 24px;
  font-size: 20px;
  font-weight: bold;
  position: relative;
  margin-block-start: 0.5em !important;
  margin-block-end: 0.5em !important;
}
.stat-card .stat-card-main .stat-placeholder::before {
  content: "--";
  color: #004a9a;
  position: absolute;
  top: 0;
  left: 0;
}
.stat-card .active-indicator {
  display: none;
}

.stat-card.clickable:active {
  transform: translateY(2px);
  box-shadow: none;
}

.stat-card.active {
  background-color: #e7f3ff;
}
.stat-card.active .stat-title {
  color: #4a5568;
}

.stat-card:first-child {
  margin-left: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/DetailCard/DetailCard.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,iHAAA;AACF;AAGI;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,oCAAA;EACA,kCAAA;EACA,2BAAA;EACA,2BAAA,EAAA,sCAAA;AADN;AAII;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AAFN;AAGM;EACE,eAAA;AADR;AAKI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oCAAA;EACA,kCAAA;AAHN;AAKM;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AAHR;AAQE;EACE,aAAA;AANJ;;AAUA;EACE,0BAAA;EACA,gBAAA;AAPF;;AAUA;EACE,yBAAA;AAPF;AAUE;EACE,cAAA;AARJ;;AAYA;EACE,yBAAA;AATF","sourcesContent":[".stat-card {\r\n  background-color: #e2e8f0;\r\n  padding: 10px;\r\n  width: 150px;\r\n  height: 70px;\r\n  margin: 5px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  transition: transform 0.1s ease-out, box-shadow 0.1s ease-out,\r\n  background-color 0.2s ease, border-color 0.2s ease;\r\n\r\n  .stat-card-main {\r\n    .stat-title {\r\n      color: #686868;\r\n      font-size: 14px;\r\n      margin-bottom: 2px;\r\n      margin-block-start: 0.5em !important;\r\n      margin-block-end: 0.5em !important;\r\n      font-weight: 500 !important;\r\n      transition: color 0.2s ease; /* Smooth color transition for title */\r\n    }\r\n\r\n    .stat-value {\r\n      color: #004a9a;\r\n      font-size: 18px;\r\n      font-weight: bold;\r\n      .currency-symbol {\r\n        font-size: 18px;\r\n      }\r\n    }\r\n\r\n    .stat-placeholder {\r\n      width: 40px;\r\n      height: 24px;\r\n      font-size: 20px;\r\n      font-weight: bold;\r\n      position: relative;\r\n      margin-block-start: 0.5em !important;\r\n      margin-block-end: 0.5em !important;\r\n\r\n      &::before {\r\n        content: \"--\";\r\n        color: #004a9a;\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  .active-indicator {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.stat-card.clickable:active {\r\n  transform: translateY(2px);\r\n  box-shadow: none;\r\n}\r\n\r\n.stat-card.active {\r\n  background-color: #e7f3ff;\r\n  //border-left-color: var(--primary-color, #0056b3); /* Accent border on the left */\r\n\r\n  .stat-title {\r\n    color: #4a5568;\r\n  }\r\n}\r\n\r\n.stat-card:first-child {\r\n  margin-left: 0 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
